import React from "react";

export function useIsMobile(): boolean {
	const [value, setValue] = React.useState(isMobile());
	React.useEffect(() => {
		const handler = (): void => {
			setValue(isMobile());
		};
		window.addEventListener("resize", handler);
		return () => {
			window.removeEventListener("resize", handler);
		};
	}, []);
	return value;
}

export function isMobile(): boolean {
	return window.innerWidth < 768;
}
